import { IReverbSettings } from "../utils/reverbEffect"

export enum AcousticSettingsPreset {
    Custom,
    Auditorium,
    ConcertHall,
    Arena,
    Hangar,
    Alley,
    Forest,
    ParkingLot,
}

export const getAcousticSettingsPresetDisplayName = (preset: AcousticSettingsPreset) => {
	switch (preset) {
		case AcousticSettingsPreset.Forest: return "Forest / Default";
		default: return AcousticSettingsPreset[preset].replace(/([A-Z])/g, ' $1').trim();
	}
}

export interface IAcousticSettings {
    preset: AcousticSettingsPreset,
    reverbSettings: IReverbSettings,
}

export const auditoriumReverbSettings: IReverbSettings = {
	dryGain: 1.0,
	wetGain: 0.7,
	earlyDelay: 0.02,
	density: 20,
	lateDelay: 0.03,
	decayTime: 3,
	hfCutoff: 5850,
	hfDecay: 0.14,
};

export const concertHallReverbSettings: IReverbSettings = {
	dryGain: 1.0,
	wetGain: 0.64,
	earlyDelay: 0.05,
	density: 14.4,
	lateDelay: 0.029,
	decayTime: 2.1,
	hfCutoff: 5650,
	hfDecay: 0.62,
};

export const arenaReverbSettings: IReverbSettings = {
	dryGain: 1.0,
	wetGain: 0.72,
	earlyDelay: 0.02,
	density: 20,
	lateDelay: 0.05,
	decayTime: 3.5,
	hfCutoff: 4500,
	hfDecay: 0.33,
};

export const hangarReverbSettings: IReverbSettings = {
	dryGain: 1.0,
	wetGain: 0.72,
	earlyDelay: 0.02,
	density: 16.9,
	lateDelay: 0.07,
	decayTime: 5,
	hfCutoff: 3300,
	hfDecay: 0.03,
};

export const alleyReverbSettings: IReverbSettings = {
	dryGain: 1.0,
	wetGain: 0.4,
	earlyDelay: 0.007,
	density: 5,
	lateDelay: 0.011,
	decayTime: 1.1,
	hfCutoff: 8300,
	hfDecay: 0.86,
};

export const forestReverbSettings: IReverbSettings = {
	dryGain: 1.0,
	wetGain: 0.23,
	earlyDelay: 0.162,
	density: 11.5,
	lateDelay: 0.017,
	decayTime: 0.5,
	hfCutoff: 760,
	hfDecay: 0.54,
};

export const parkingLotReverbSettings: IReverbSettings = {
	dryGain: 1.0,
	wetGain: 0.57,
	earlyDelay: 0.008,
	density: 10.4,
	lateDelay: 0.09,
	decayTime: 1.7,
	hfCutoff: 20000,
	hfDecay: 1.0,
};

export const getReverbSettingsForPreset = (
	preset: AcousticSettingsPreset,
	currentReverSettings: IReverbSettings
): IReverbSettings => {
	switch (preset) {
		case AcousticSettingsPreset.Custom: {
			return currentReverSettings;
		}
		case AcousticSettingsPreset.Auditorium: {
			return auditoriumReverbSettings;
		}
		case AcousticSettingsPreset.ConcertHall: {
			return concertHallReverbSettings;
		}
		case AcousticSettingsPreset.Arena: {
			return arenaReverbSettings;
		}
		case AcousticSettingsPreset.Hangar: {
			return hangarReverbSettings;
		}
		case AcousticSettingsPreset.Alley: {
			return alleyReverbSettings;
		}
		case AcousticSettingsPreset.Forest: {
			return forestReverbSettings;
		}
		case AcousticSettingsPreset.ParkingLot: {
			return parkingLotReverbSettings;
		}
	}
};
